import React from 'react';
import Icon from '../../../AppIcon';

const MetricsGrid = ({ metrics }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {metrics?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow duration-200">
          <div className="flex items-center justify-between mb-4">
            <div className={`p-3 rounded-lg ${metric?.bgColor}`}>
              <Icon name={metric?.icon} size={24} className={metric?.iconColor} />
            </div>
            {metric?.trend && (
              <div className={`flex items-center space-x-1 text-sm ${
                metric?.trend > 0 ? 'text-success' : 'text-error'
              }`}>
                <Icon 
                  name={metric?.trend > 0 ? 'TrendingUp' : 'TrendingDown'} 
                  size={16} 
                />
                <span>{Math.abs(metric?.trend)}%</span>
              </div>
            )}
          </div>
          
          <div className="space-y-2">
            <h3 className="text-2xl font-bold text-foreground">{metric?.value}</h3>
            <p className="text-sm text-muted-foreground">{metric?.label}</p>
            {metric?.subtitle && (
              <p className="text-xs text-muted-foreground">{metric?.subtitle}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsGrid;